export class ContentTxt {


    constructor() {



    }

    public static whichContent(key) {

        return ContentTxt[key]
    }


    private static aboutyouDash = {
        label: "Let’s get started!\n Creating a Will with WiserNow\n" +
    "is simple, and only takes\n" +
    "about 10 minutes. The first step is to collect\n" +
    "some basic details from you.\n",
        image: "url('assets/media/bg/back.svg')",
    }
    private static executorDash =  {
        label:"Next up, we’ll ask you to nominate executors, who’ll carry out your instructions on your behalf when the time comes.",
        image: "url('assets/media/bg/back.svg')",

    }

    private static fnishDash =  {
        label:"Process is complete, you can choose a plan and download your Will",
        image: "url('assets/media/bg/back.svg')",

    }
    private static estateDash = {
        label:"Step 3 is next, where you’ll define how you’d like your estate divided across the people and charities that are important to you.",
        image: "url('assets/media/bg/back.svg')",

    }
    private static giftsDash = {
        label:"In the next step we’ll ask you to list and allocate any specific gifts you’d like left to the people and charities that are important to you",
        image: "url('assets/media/bg/back.svg')",

    }
    private static funeralwishesDash = {
        label:"In the final step we will ask you to nominate your funeral wishes so that they are included in your Will and undertaken by your executor.",
        image: "url('assets/media/bg/back.svg')",
    }

    /*
    *  <i class='theme-color-orange font-size-sm-italic'>  free will  </i>*/
    private static dashboard: Content = {
        label: "Let’s get started!\n Creating a Will with WiserNow\n" +
            "is simple, and only takes\n" +
            "about 10 minutes. The first step is to collect\n" +
            "some basic details from you.\n",
        image: "url('assets/media/bg/back.svg')",
        heading: "Creating your Will",
        headingTextAlign: "text-align-center"
    }
    private static reset_passowrd: Content = {
        label: ' Reset your Password.',
        image: "url('assets/media/bg/back.svg')",
    }


    private static registration: Content = {
        label: ' Creating your account is easy and allows you to come back any time to resume your progress, download your Will, or make edits.',
        image: "url('assets/media/bg/back.svg')",
    }
    private static reg: Content = {
        label: ' Creating your account is easy and allows you to come back any time to resume your progress, download your Will, or make edits.',
        image: "url('assets/media/bg/back.svg')",
    }

    private static login: Content = {
        label: 'Login to WiserNow using your existing account details, or use the “Forgot Password” link if required. If you’ve not yet created an account, click “Sign Up” to set one up – it only takes 30 seconds!',
        image: "url('assets/media/bg/back.svg')",
    }


    private static aboutyou: Content = {
        label: "Let\'s start by getting to know you. Providing your details allows us to\n" +
            "get started with creating your\n" +
            "WiserNow free Will.\n",
        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 100,
        nextPage: 'maritalstatus',
        previousPage:'dashboard'
    }

    private static maritalstatus: Content = {
        label: "Marital status is your legally defined\n" +
            "marital state, not necessarily your\n" +
            "current living arrangement.\n" +
            "Understanding this status is essential\n" +
            "as it helps us capture information\n" +
            "associated with other important\n" +
            "people in your life where necessary.\n",
        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 101,
        nextPage: 'childrens',
        previousPage:"aboutyou"

    }
    private static single: Content = {
        label: "A marital status of single generally refers to a situation where there is no significant partner - via marriage or de facto relationship – which should be included in your Will.",
        image: "url('assets/media/bg/back.svg')",
        level: 101,
        nextPage: 'childrens',
        previousPage:"aboutyou"
    }

    private static married: Content = {
        label: "A marital status of married relates to an active legal marriage.\n" +
            "\n" +
            "Marriage generally revokes an existing Will. Accordingly, if your marital status changes, you should come back and update your Will.",
        image: "url('assets/media/bg/back.svg')",
        level: 101,
        nextPage: 'childrens',
        previousPage:"aboutyou"
    }

    private static deFacto: Content = {
        label: "Whilst legally subjective, a de facto relationship is generally where a long-term or permanent relationship exists, but is not bound by formal marriage. A de facto partner may be considered and included in your Will.",
        image: "url('assets/media/bg/back.svg')",
        level: 101,
        nextPage: 'childrens',
        previousPage:"aboutyou"
    }



    private static childrens: Content = {
        label: " <div class=' '>Understanding who your biological and\n" +
            "legally adopted children are is vital to\n" +
            "ensure they’re assigned a guardian in\n" +
            "your Will.\n</div>  <div class='margin-top-20'>Other children, such as step-children,\n" +
            "can be included as beneficiaries in later\n" +
            "steps.\n</div>",
        image: "url('assets/media/bg/back.svg')",
        level: 102,
        nextPage: 'pets',
        previousPage:"maritalstatus"
    }


    private static haveChildren: Content = {
        label: " <div class=' '>Do not add any step children who you have not legally adopted. If you wish to leave step children part of your estate, you can do this in a later step.</div>",
        image: "url('assets/media/bg/back.svg')",
        level: 102,
        nextPage: 'pets',
        previousPage:"maritalstatus"
    }

    private static pets: Content = {
        label: " <div class=' '>Pets can be nominated and\n" +
            "assigned to a guardian in your\n" +
            "Will too. List your pets that you’d\n" +
            "like included and assign them to\n" +
            "someone you’d like to assume\n" +
            "guardianship.\n</div>",
        image: "url('assets/media/bg/back.svg')",
        level: 103,
        nextPage: 'summary',
        previousPage:"childrens"
    }

    private static havePets: Content = {
        label: " <div class=' '>Pets can be nominated and\n" +
            "assigned to a guardian in your\n" +
            "Will too. List your pets that you’d\n" +
            "like included and assign them to\n" +
            "someone you’d like to assume\n" +
            "guardianship.\n</div>",
        image: "url('assets/media/bg/back.svg')",
        level: 103,
        nextPage: 'summary',
        previousPage:"childrens"
    }

    private static summary: Content = {
        label: " <div class='font-weight-bolder font-size-h1-lg  '>Step 1 is complete!\n</div>  <div class='margin-top-20'> Please check the details\n" +
            "provided and ensure they’re\n" +
            "accurate before moving on</div>",

        image: "url('assets/media/bg/back.svg')",
        level: 103,
        nextPage: 'pets',
        previousPage:"pets"
    }


    private static executor: Content = {
        label: " <div class='font-weight-bolder font-size-h1-lg  '>   An executor is the person you\n" +
            "entrust to carry out the\n" +
            "instructions in your Will.\n</div>  <div class='margin-top-20'>Executors needs to be over the\n" +
            "age of 18, and should be\n" +
            "someone who you trust to act\n" +
            "impartially when it comes time\n" +
            "to activate your Will.\n</div>",
        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 201,
        nextPage: 'backupexecutor',
        previousPage:'dashboard'
    }

    private static backupexecutor: Content = {
        label: "   <div class=''> A backup executor is nominated in\n" +
            "order to carry out the wishes of your\n" +
            "Will should your primary executor be\n" +
            "unable to for any reason.\n</div>",
        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 202,
        nextPage: 'executorsummary',
        previousPage:'executor'

    }

    private static executorsummary: Content = {
        label: " <div class='font-weight-bolder font-size-h1-lg  '>   Step 2 complete!\n</div>  <div class='margin-top-20'> Please check the details provided and\n" +
            "ensure they’re accurate before moving\n" +
            "on.\n</div>",

        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 201,
        nextPage: 'estate',
        previousPage:'backupexecutor'

    }



    private static estate: Content = {
        label: "<div>Your residual estate is everything\n" +
            "left after all general and specific\n" +
            "assets have been allocated, and\n" +
            "after any outstanding debts have\n" +
            "been paid.\n</div>  <div class='margin-top-20'>Please tell us how you’d like your\n" +
            "residual estate divided across\n" +
            "either people or charities of your\n" +
            "choice.\n</div>",

        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        nextPage: 'charity',
        level: 301,
    previousPage:'dashboard'
    }

    private static charity: Content = {
        label: " <div >Your free Will is made possible\n" +
            "through the support of charities\n" +
            "that are dedicated to making\n" +
            "Australia and the world a better\n" +
            "place.\n</div> <div class='margin-top-20'>Please tell us about any charities\n" +
            "you’d like to benefit from receiving\n" +
            "a percentage of your estate.\n </div> ",

        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        nextPage: 'estate',
        level: 301,
        previousPage:"estate"
    }


    private static estatedivision: Content = {
        label: "  <div class=''>Please tell us what percentage of\n" +
            "your estate you would like to\n" +
            "allocate to each beneficiary.\n</div>",

        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        nextPage: 'estatebackup',
        level: 302,
        previousPage:"charity"

    }

    private static estatebackup: Content = {
        label: "  <div class='font-15-m'> Backup Beneficiaries are people who would\n" + "inherit your estate should there be no surviving\n" + "primary beneficiaries</div> " +
            "<div class='font-15 margin-top-20 '>Other things to consider:\n</div>" +
            "<div class='  font-15 margin-top-20'>Selecting multiple specific backup\n" + "beneficiaries will result in the beneficiary’s\n" + "share being split evenly between them.\n</div>" +
            "<div class=' font-15 margin-top-20 '>In the event a backup beneficiary passes\n" + "away before you and was your child, their\n" + "share will be allocated to their surviving\n" + "children equally.\n</div>" +
            "<div class=' font-15 margin-top-20 '>In the event all backup beneficiaries pass\n" + "away before you and were not your children,\n" + "their share will be returned to the residual\n" + "estate.\n</div>",

        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        nextPage: 'estatesummary',
        level: 303,
        previousPage:"estatedivision"
    }


    private static estatesummary: Content = {
        label: " <div class='font-weight-bolder font-size-h1-lg  '> Step 3 complete!\n</div>  <div class='margin-top-20'> Please check the details\n" +
            "provided and ensure they’re\n" +
            "accurate before moving on.\n</div>",

        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 303,
        nextPage: 'gifts',
        previousPage:"estatebackup"
    }



    private static gifts: Content = {
        label: "<div class=''>Please tell us about any specific gifts\n" +
            "you would like to leave to people or\n" +
            "charities. Try to be as specific as\n" +
            "possible when describing these gifts.\n</div><div class='margin-top-20'> Your free Will is made possible through\n" +
            "the support of charities that are\n" +
            "dedicated to making Australia and the\n" +
            "world a better place. Please tell us\n" +
            "about any charities you’d like to benefit\n" +
            "from receiving a specific gift from you.\n</div>",
        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 401,
        nextPage: 'giftsummary',
        previousPage:'dashboard'
    }

    private static addgift: Content = {
        label: "You can leave gifts to people or charities.",
        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 401,
        nextPage: 'gifts',
        previousPage:'gifts'
    }

    private static giftsummary: Content = {
        label: " <div class='font-weight-bolder font-size-h1-lg  '>Step 4 complete!\n</div>  <div class='margin-top-20'>Please check the details provided and\n" +
            "ensure they’re accurate before moving\n" +
            "on.\n</div>",
        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 401,
        previousPage:'gifts',
        nextPage: 'giftsummary'
    }


    private static funeralwishes: Content = {
        image: "url('assets/media/bg/back.svg')",
        label: "<div class=''>Telling us about any specific\n" +
            "preferences you have for your funeral\n" +
            "allows them to be included in your\n" +
            "Will and to be carried out by your\n" +
            "executor according to your wishes.\n</div><div class='margin-top-20'> Have you thought about pre-paying for your funeral, in order to remove the burden on your family when the time comes? Tell us if you’d like us to help find the perfect funeral director here too.</div>",

        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 501,
        previousPage:'dashboard'

    }
    private static funeralsummary: Content = {
        label: " <div class='font-weight-bolder font-size-h1-lg  '> Step 5 complete!\n</div>  <div class='margin-top-20'> Please check the details provided\n" +
            "and ensure they’re accurate\n" +
            "before moving on</div>",

        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        level: 501,
        previousPage:'funeralwishes'

    }



    private static thankyou: Content = {
        label: " <div class='font-weight-bolder font-size-h1-lg  '>       Help the charities you support</div>  <div class='margin-top-20'> Opting in to share your contact details in this section is a big help to your charities as it allows them to thank you for your gift and include your gift in their planned giving goals.</div>",

        image: "url('assets/media/bg/back.svg')",
        heading: "The Process",
        headingTextAlign: "text-align-center",
        nextPage: 'finish',
        previousPage:'dashboard'

    }


}

export type Content = {
    label?;
    image?;
    heading?;
    headingTextAlign?;
    level?: number,
    nextPage?,
    previousPage?

}
